import React, { PropTypes } from 'react'
import Heading from 'components/Heading'
import Card from 'components/Card'
import Loading from 'components/Loading'
import Alert from 'components/Alert'
import FileUploader from 'components/FileUploader/FileUploader'
import FineUploaderTraditional from 'fine-uploader-wrappers'
import SubmitButton from 'components/SubmitButton'
import constants from 'constants'
import HierarchyUploadList from './components/Hierarchy/HierarchyUploadList'
import { agent } from 'utils/api'

const styles = Object.assign(
  {},
  require('./Hierarchies.scss'),
  require('components/Table/Table.scss'),
  { columns: require('./columns.scss') },
)

class HierarchyUploadView extends React.Component {
  static propTypes = {
    completeText: PropTypes.string,
    ctaText: PropTypes.string,
    hierarchyUpload: PropTypes.object.isRequired,
    initUpload: PropTypes.object.isRequired,
    sendNotification: PropTypes.object.isRequired,
    submittingText: PropTypes.string,
  }
  static defaultProps = {
    ctaText: 'Upload',
    completeText: 'Uploaded',
    submittingText: 'Uploading',
  }

  constructor() {
    super()

    this.state = {
      submittedFiles: [],
      uploader: null,
      isComplete: false,
      isPosting: false,
    }
  }

  componentWillMount() {
    this.setState({ uploader: this.myUploader() })
  }

  setSubmittedFiles = (submittedFiles) => {
    this.setState({ submittedFiles })
  }

  setFileUploaderResponse = (response) => {
  }

  _initForm = () => {
    this.setState({ isPosting: false }, () => {
      this.state.uploader.methods.reset()
      this.setState({ isComplete: true })
      this.setState({ submittedFiles: [] })
      setTimeout(() => {
        this.props.initUpload()
        this.setState({ isComplete: false })
      }, 2000)
    })
  }

  _handleSubmit = () => {
    if (this.state.submittedFiles.length > 0) {
      this.setState({ isPosting: true }, () => {
        this.state.uploader.methods.uploadStoredFiles()
      })
    }
  }

  _handleAllUploadComplete = (id, name, response) => {
    if (response.success) {
      // this._initForm()
    } else {
      this.props.sendNotification(response.error)
    }
  }

  _handleUploadComplete = (id, name, response) => {
    if (response.success || response.error) {
      this.props.sendNotification(response.error)
    }
    this._initForm()
  }

  _handleUploadError = (id, name, response) => {
    this.props.sendNotification((response.error ? response.error : response))
    this._initForm()
  }

  // Moving logic from Uploader ...
  myUploader = () => {
    // const { allowedExtensions, uploadID, maxFileSize } = this.props
    const allowedExtensions = ['csv']
    // const uploadID = '1234'
    const maxFileSize = constants.HIERARCHY.UPLOAD_MAX_FILESIZE
    const maxFileNumber = 1

    return new FineUploaderTraditional({
      options: {
        debug: true,
        autoUpload: false,
        request: {
          endpoint: agent.FileUploader.uploadhierarchy(),
        },
        cors: {
          expected: true,
          sendCredentials: true,
        },
        // deleteFile: {
        //   enabled: true,
        // },
        validation: {
          acceptFiles: allowedExtensions.map(e => `.${e}`),
          allowedExtensions,
          sizeLimit: maxFileSize,
          itemLimit: maxFileNumber,
        },
        chunking: {
          enabled: false,
          partSize: 5242880, // 5mb
          concurrent: {
            enabled: true,
          },
          success: {
          },
        },
        callbacks: {
          // onSubmit: this.uploaderSubmit,
          // onSubmitted: this.uploaderSubmitted,
          // onComplete: this._handleFormSubmit,
          onComplete: this._handleUploadComplete,
          onError: this._handleUploadError,
          // onStatusChange: this.uploaderStatusChange,
          // onProgress: this.uploaderProgress,
          // onUploadChunk: this.uploadChunk,
          // onUploadChunkSuccess: this.uploadChunkSuccess,
          // onUpload: this.startUpload,
          onAllComplete: this._handleAllUploadComplete,
          // onCancel: this.onCancel,
          // onDelete: this.onDelete,
        },
      },
    })
  }

  canSubmit = () => {
    return (this.state.submittedFiles.length > 0)
  }

  render() {
    const {
      ctaText,
      completeText,
      submittingText,
      hierarchyUpload,
    } = this.props

    const pendingHierarchy =
      hierarchyUpload.hierarchyUploaded.filter(ppr => (String(ppr.status) === constants.HIERARCHY.UPLOAD_STATUS.PENDING || String(ppr.status) === constants.HIERARCHY.UPLOAD_STATUS.INPROGRESS))

    // eslint-disable-next-line dot-notation
    // const form = this.props.forms['hierarchyUpload']
    if (hierarchyUpload.isFetching) {
      return (<Loading pageLoading />)
    }

    return (
      <div className={styles.content}>
        <Alert showCloseButton={false} type="info">
        This upload is for bulk updating the hierarchy changes of market or growth leaders. The template includes separate columns for market leaders and growth leaders. Column titles are <b>case-sensitive</b>; ensure they match the template exactly.
        </Alert>
        <section className={styles.section}>
          {hierarchyUpload.fetched && hierarchyUpload.hierarchyUploaded &&
          <div>
            <HierarchyUploadList
              header={constants.HIERARCHY.UPLOAD_STATUS.COMPLETED}
              hierarchyUploadItems={hierarchyUpload.hierarchyUploaded.filter(ppr => (String(ppr.status) !== constants.HIERARCHY.UPLOAD_STATUS.TEMPLATE))}
            />
            <HierarchyUploadList
              header={`Download ${constants.HIERARCHY.UPLOAD_STATUS.TEMPLATE}`}
              hierarchyUploadItems={hierarchyUpload.hierarchyUploaded.filter(ppr => String(ppr.status) === constants.HIERARCHY.UPLOAD_STATUS.TEMPLATE)}
            />
          </div>}
          <div>
            <Heading noTopPadding>Upload hierarchy CSV</Heading>
            <Card>
              {pendingHierarchy.length > 0 &&
                <div className={styles.uploadSection}>
                  <Alert showCloseButton={false} type="info">
                Hierarchy upload in progress, please check back later...
                </Alert>
                </div>
              }
              { pendingHierarchy.length === 0 &&
              <div className={styles.uploadSection}>
                <Alert showCloseButton={false} type="info">
                Ensure filenames only use numbers, letters and underscores.
                </Alert>
                <FileUploader
                  allowedExtensions={['csv']}
                  handleDeleteExistingFile={file => console.log('### delete', file)}
                  handleSelectedFile={() => console.log('### selected ###')} // 1 MB = 1000 * 1000 * 1024 bytes
                  labelWidth={20}
                  maxFileSize={constants.HIERARCHY.UPLOAD_MAX_FILESIZE}
                  multiple={false}
                  setFileUploaderResponse={this.setFileUploaderResponse}
                  setSubmittedFiles={this.setSubmittedFiles}
                  uploadDescText="CSV only, max 20mb."
                  // disabled={fileUploaderDisabled}
                  uploadTitle="Add files here"
                  uploader={this.state.uploader}
                />
                <div className={styles.footer}>
                  <SubmitButton
                    isLarge
                    complete={this.state.isComplete}
                    completeText={completeText} // Add validation rules
                    disabled={!this.canSubmit()}
                    // onClick={() => this._handleSubmit()}
                    onClick={() => this._handleSubmit()}
                    submitting={this.state.isPosting}
                    submittingText={submittingText}
                  >
                    {ctaText}
                  </SubmitButton>
                </div>
              </div>
              }
            </Card>
          </div>
        </section>
      </div>
    )
  }
}

export default HierarchyUploadView



// WEBPACK FOOTER //
// ./src/views/PartnerHierarchy/HierarchyUpload.js